import styled, { keyframes } from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import { TbLoader2 } from "react-icons/tb";
import { useState } from "react"
import useApi from "../../../hooks/useApi";


const Title = styled.h2`
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    color: #333;
`
const Subtitle = styled.p`
    font-size: 14px;
    color: #555;
    margin-top: 10px;
`
const BotoesContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 10px;
`
const Botao = styled.button`
    width: 120px;
    height: 34px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    color: white;
    background-color: ${props => props.cancel ? '#6c757d' : '#dc3545'};
    &:hover {
        background-color: ${props => props.cancel ? '#5a6268' : '#c82333'};
    }
`
const animacaoLoading = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`
const IconeLoading = styled(TbLoader2)`
    width: 20px;
    height: 20px;
    animation: ${animacaoLoading} 1s linear infinite;
`

const ModalDeleteArea = ({ obj, setSelectedArea, updateAreas }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [ loading, setLoading ] = useState( false );

    const cancelar = () => {
        setSelectedArea(null);
        closeModal();
    }

    const deleteArea = async () => {

        setLoading( true );

        try{

            await api.post("/Painel/API/Desvios/DeleteAreaCatalogo/", {
                id: obj.id
            })

            await updateAreas();
            setSelectedArea(null);
            closeModal();

        }catch( error ){

            console.error( error );

        }finally{

            setLoading( false );

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <Title>APAGAR ÁREA</Title>
                    <Subtitle>Tem certeza que deseja apagar a área <strong>{obj.area}</strong>? Esta ação não pode ser desfeita.</Subtitle>
                    <BotoesContainer>
                        <Botao cancel onClick={cancelar} >CANCELAR</Botao>
                        <Botao disabled={loading} onClick={deleteArea} >
                            {loading ? <IconeLoading /> : 'APAGAR'}
                        </Botao>
                    </BotoesContainer>
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalDeleteArea;